var _path;
import * as React from "react";
import { SvgIcon } from '@mui/material';
const SvgArticle = props => /*#__PURE__*/React.createElement(SvgIcon, props, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20.25 3.75H3.75a1.5 1.5 0 00-1.5 1.5v13.5a1.5 1.5 0 001.5 1.5h16.5a1.5 1.5 0 001.5-1.5V5.25a1.5 1.5 0 00-1.5-1.5zm0 15H3.75V5.25h16.5v13.5zm-3-9.75a.75.75 0 01-.75.75h-9a.75.75 0 010-1.5h9a.75.75 0 01.75.75zm0 3a.75.75 0 01-.75.75h-9a.75.75 0 110-1.5h9a.75.75 0 01.75.75zm0 3a.75.75 0 01-.75.75h-9a.75.75 0 110-1.5h9a.75.75 0 01.75.75z"
})));
export default SvgArticle;